import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    if (!localStorage.getItem("ucp_cookie_consent")) setVisible(true);
  }, []);

  const answer = (val) => {
    localStorage.setItem("ucp_cookie_consent", val);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[90] bg-white border border-[#E6EBF1] rounded-2xl p-5 shadow-2xl shadow-[#0A2540]/15 animate-fade-up"
    >
      <div className="flex items-start gap-3">
        <Cookie className="text-[#635BFF] mt-0.5 shrink-0" size={20} />
        <div>
          <p className="text-sm text-[#0A2540] font-semibold">{t("cookies.title")}</p>
          <p className="text-xs text-[#425466] mt-1 leading-relaxed">{t("cookies.body")}</p>
          <div className="flex items-center gap-2 mt-3">
            <Button
              data-testid="cookie-accept-btn"
              size="sm"
              className="bg-[#635BFF] hover:bg-[#0A2540] text-white rounded-full px-4"
              onClick={() => answer("accepted")}
            >
              {t("cookies.accept")}
            </Button>
            <Button
              data-testid="cookie-decline-btn"
              size="sm"
              variant="outline"
              className="border-[#E6EBF1] text-[#425466] hover:bg-[#F6F9FC] rounded-full px-4"
              onClick={() => answer("declined")}
            >
              {t("cookies.decline")}
            </Button>
            <Link to="/legal/cookies" className="text-xs text-[#635BFF] hover:underline ml-1">
              {t("cookies.learn")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
